import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form, Row, Col } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';

const MaintenanceCard = ({ maintenance }) => {
  if (!maintenance) return null;

  const { startDate, endDate } = maintenance;

  const getMaintenanceStatus = () => {
    if (!startDate || !endDate) {
      return { status: 'No maintenance scheduled', variant: 'info' };
    }
    const now = moment();
    const start = moment.utc(startDate).local();
    const end = moment.utc(endDate).local();

    if (now.isBetween(start, end, null, '[]')) {
      return {
        status: `Maintenance in progress until ${end.format('DD-MM-YYYY HH:mm')} at your local time`,
        variant: 'danger',
      };
    }
    if (now.isBefore(start)) {
      return { status: `Next maintenance: ${start.format('DD-MM-YYYY HH:mm')} at your local time`, variant: 'warning' };
    }
    return { status: 'Last maintenance completed', variant: 'success' };
  };

  return (
    <Card className="mt-3">
      <Card.Header>Maintenance</Card.Header>
      <Card.Body>
        <Form>
          <Row>
            <Form.Group as={Col} md={6}>
              <Form.Label>Start Date ( UTC )</Form.Label>
              <Datetime
                value={startDate ? moment.utc(startDate) : ''}
                inputProps={{ placeholder: 'DD-MM-YYYY HH:mm', disabled: true }}
                dateFormat="DD-MM-YYYY"
                timeFormat="HH:mm"
                closeOnSelect={false}
                isValidDate={() => false}
              />
            </Form.Group>
            <Form.Group as={Col} md={6}>
              <Form.Label>End Date ( UTC )</Form.Label>
              <Datetime
                value={endDate ? moment.utc(endDate) : ''}
                inputProps={{ placeholder: 'DD-MM-YYYY HH:mm', disabled: true }}
                dateFormat="DD-MM-YYYY"
                timeFormat="HH:mm"
                closeOnSelect={false}
                isValidDate={() => false}
              />
            </Form.Group>
          </Row>

          <Row>
            <Form.Group as={Col} className="mt-2">
              <div className={`alert alert-${getMaintenanceStatus().variant}`} role="alert">
                {getMaintenanceStatus().status}
              </div>
            </Form.Group>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

MaintenanceCard.propTypes = {
  maintenance: PropTypes.shape({
    isActive: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default MaintenanceCard;
